export default "__VITE_ASSET__8d85c540__"